var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"chat"}},[_c('h2',[_c('font-awesome-icon',{attrs:{"icon":['far', 'comments']}}),_vm._v(" Berichten")],1),_c('chat',{attrs:{"assignmentId":parseInt(this.$route.params.id),"disabled":_vm.completed}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }